<div id="bannerFunction" [className]="isListPreview ? 'list-preview live_preview' : 'banner-live-preview'">
  <div id="bannerFunctionLayout" class="banner-function-layout" [ngClass]="((bannerFunction === 'Default' || bannerFunction === 'URL') && presentpage === 'asset-library') ? 'new-previews-banner-function-layout': ((bannerFunction === 'Default' || bannerFunction === 'URL') && presentpage === 'profile') ? 'profile-new-previews-banner-function-layout' : ''">
    <div id="bannerHeading" class="mb-3 heading-text">
      <span i18n="@@banner-function.header.banner-function">Banner Function</span>
    </div>
    <div id="bannerFunctionFormCheck" class="form-check line-break-div">
      <input class="form-check-input" type="radio" name="banner_function" value="Content Pages" id="cont_pages"
        [checked]="isContentPagesChecked" (click)="selectBannerFunction('Content Pages')" />
      <label class="form-check-label banner-options-label" for="cont_pages">
        <span i18n="@@banner-function.radio-type.content-pages">Content Pages</span>
        <span class="carbonhue d-block" i18n="@@banner-function.radio-type.content-pages-text">Display up to 3 customizable pages.</span>
      </label>
    </div>
    <div id="bannerFunctionHeadingText" class="mt-3 mb-3 heading-text">
      <span i18n="@@banner-function.text.or-label">OR</span>
    </div>
    <div id="bannerFunctionUrlFormCheck" class="form-check line-break-div">
      <input class="form-check-input" type="radio" name="banner_function" value="URL Experience" id="url_exp"
        [checked]="isURLChecked" (click)="selectBannerFunction('URL')" />
      <label class="form-check-label banner-options-label" for="url_exp">
        <span i18n="@@banner-function.radio-type.url-exp">URL Experience</span>
        <span class="carbonhue d-block" i18n="@@banner-function.radio-type.url-exp-text">(This will override the content pages)</span>
      </label>
    </div>
    <iposcen-confirm-dialog #confirmModal [popupTitle]="title" [popupDesc]="description" [popupAction]="action"
      (cancelConfirm)="cancelModal()" (confirm)="confirmBannerOption()"></iposcen-confirm-dialog>
  </div>
  <iposcen-live-preview *ngIf="bannerFunction === 'Content Pages'" [sidenav]="sidenav"></iposcen-live-preview>
  <iposcen-content-live-preview [imageData]="imageData" [sidenav]="sidenav" *ngIf="bannerFunction === 'Default' || bannerFunction === 'URL' || radioType === 'URL'">
  </iposcen-content-live-preview>
</div>
